import { useEffect, useState } from "react";
import { ProductViewModel } from "../../../../viewmodels/setup/myProducts/ProductViewModel";

import { connect } from "react-redux";

import * as actions from "../../../../store/actions/index";

import { withRouter } from "../../../../shared/utility";

import ProductDetailsForm from "../../../../components/forms/setup/product/ProductDetailsForm";
import EmptyModal from "../../../../components/modals/EmptyModal";
import FormSectionLoadingSkeleton from "../../../../components/operational/FormSectionLoadingSkeleton";

function AddProduct(props) {
  const { logout } = props;
  const [optionsLoading, setOptionsLoading] = useState(true);
  const {
    allergensOptions,
    createProduct,
    getAllergensForDropdown,
    unitOfMeasureOptions,
    getUnitOfMeasuresForDropdown,
    getProductTypes,
    productTypeOptions,
    emptyModal,
    setEmptyModelOpen,
  } = ProductViewModel(logout);

  useEffect(() => {
    Promise.all([
      getAllergensForDropdown(),
      getUnitOfMeasuresForDropdown(),
      getProductTypes(),
    ]).finally(() => setOptionsLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-[#F6F8FB] px-4 py-5 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl space-y-6">
        <section className="rounded-[18px] border border-[#E2E8F0] bg-white shadow-[0_1px_2px_rgba(15,23,42,0.04)]">
          <div className="border-b border-[#E2E8F0] px-6 py-5">
            <p className="text-[11px] font-semibold uppercase tracking-[0.16em] text-[#64748B]">
              Setup
            </p>
            <h1 className="mt-2 text-[1.65rem] font-semibold tracking-tight text-[#0F172A] sm:text-3xl">
              Add Product
            </h1>
            <p className="mt-2 max-w-2xl text-sm leading-6 text-[#64748B]">
              Create a finished good with product details, allergens, units of
              measure, and product type information.
            </p>
          </div>
          <div className="p-5 sm:p-6">
            {optionsLoading ? (
              <FormSectionLoadingSkeleton rows={6} />
            ) : (
              <ProductDetailsForm
                actionCall={createProduct}
                allergensOptions={allergensOptions}
                isEdit={false}
                unitOfMeasureOptions={unitOfMeasureOptions}
                productTypeOptions={productTypeOptions}
              />
            )}
          </div>
        </section>
      </div>
      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AddProduct),
);
